export default __webpack_public_path__ + "static/media/men.cc1971b0.png";